import { t } from "@/i18n-js/instance";
import { Tab } from "@circle-react-uikit/TabV2";
import { Typography } from "@circle-react-uikit/Typography";
import { BannerTab } from "./BannerTab";

const translationRoot = "courses.directory.options_modal.banner";
export const Banner = () => (
  <div className="flex flex-col gap-y-8 py-8 md:py-14">
    <Typography.TitleMd color="text-darkest">
      {t([translationRoot, "title"])}
    </Typography.TitleMd>
    <Tab.Group className="overflow-y-hidden">
      <Tab.List>
        <Tab>{t([translationRoot, "tabs.logged_in"])}</Tab>
        <Tab>{t([translationRoot, "tabs.logged_out"])}</Tab>
      </Tab.List>
      <Tab.Panels>
        <Tab.Panel>
          <BannerTab isLoggedIn />
        </Tab.Panel>
        <Tab.Panel>
          <BannerTab isLoggedIn={false} />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  </div>
);
